export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'accent' | 'danger'
export type ButtonSize = 'lg' | 'card' | 'md' | 'sm'

const base =
  // Astra §4: 12px control radius; disabled = Surface 2 + secondary text, no shadow (never faded essential text).
  'press inline-flex items-center justify-center gap-2 rounded-[12px] font-semibold tracking-[-0.01em] select-none text-center ' +
  'disabled:bg-sunk disabled:text-ink-2 disabled:shadow-none disabled:ring-0 disabled:pointer-events-none aria-disabled:bg-sunk aria-disabled:text-ink-2 aria-disabled:pointer-events-none'

const sizes: Record<ButtonSize, string> = {
  lg: 'min-h-[52px] px-6 text-[16px]', // primary 52px
  card: 'min-h-12 px-5 text-[16px]', // the 48px primary action inside a card (Astra #5)
  md: 'min-h-11 px-4 text-[16px]', // control label 16/21
  sm: 'min-h-11 px-4 text-[14px]', // smaller type, same 44px touch target
}

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-accent text-on-accent', // BRAND.md 8: accent fill, square
  secondary: 'gh-fill bg-transparent text-ink ring-1 ring-inset ring-boundary', // BRAND.md 8 outline button
  ghost: 'text-ink active:bg-sunk',
  accent: 'bg-accent text-on-accent',
  danger: 'bg-danger text-white',
}

export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'lg', extra = ''): string {
  return `${base} ${sizes[size]} ${variants[variant]} ${extra}`.trim()
}
